import { Button } from '@shared/components';
import { PYLON_HELP_CENTER_URL } from '@shared/constants';
import { AskVeeHeaderButton } from '@shared/plugin/features/AskVeeHeaderButton';
import { Menu } from '@shared/plugin/features/Menu';
import { GoArrowLeft } from 'react-icons/go';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
  hasMenu?: boolean;
  webBaseUrl?: string;
}

export const Layout = ({ hasMenu, children, webBaseUrl }: LayoutProps) => {
  const navigate = useNavigate();

  return (
    <div className="text-body-md flex h-screen flex-col overflow-hidden">
      <div className="flex flex-1 flex-col overflow-hidden">
        <div className="z-10 flex flex-row items-center justify-between bg-white p-2 text-gray-700">
          {hasMenu ? (
            <Menu hasChats />
          ) : (
            <Button
              onPress={() => navigate(-1)}
              variant="secondary"
              size="xs"
              icon={<GoArrowLeft size={12} />}
            >
              Back
            </Button>
          )}

          <div className="flex flex-row items-center gap-2">
            <AskVeeHeaderButton />
            <a href={PYLON_HELP_CENTER_URL} target="_blank" rel="noreferrer">
              <Button
                size="xs"
                icon={<MdOutlineOpenInNew className="text-brand-500" />}
                tooltip="Open Vooma Help Center"
                variant="secondary"
                iconPosition="right"
              >
                Help Center
              </Button>
            </a>
            {webBaseUrl && (
              <a href={webBaseUrl} target="_blank" rel="noreferrer">
                <Button
                  size="xs"
                  icon={<MdOutlineOpenInNew className="text-brand-500" />}
                  tooltip="Open Vooma web app"
                  variant="secondary"
                  iconPosition="right"
                >
                  Vooma
                </Button>
              </a>
            )}
          </div>
        </div>
        <div className="flex flex-1 flex-col overflow-y-hidden bg-gray-50">
          {children}
        </div>
      </div>
    </div>
  );
};
